export const DELETE_USER = 'DELETE_USER';

const defaultState = {
    currentUser: {}
};

/**
 * User reducer
 * @param  {Object} [state=defaultState] the previous state
 * @param  {Object} action               the action to apply••••••••
 * @return {Object}                      the new state
 */
export default function (state = defaultState, action) {
  switch (action.type) {
    case DELETE_USER:
      return {
        ...state,
      };
      case "UPDATE_CURRENT_USER":
        return Object.assign({}, state, {currentUser: action.currentUser})
    default:
      return state;
  }
}
